import { useMemo, useRef,useState } from 'react'
import { useForm } from 'react-hook-form'

import { PktButton,PktMessagebox, PktTextarea } from '..'

type FormData = {
  firstValue: string
  secondValue: string
}

export default function Textarea() {
  const [aValue, setAValue] = useState('')

  const [buttonValue, setButtonValue] = useState('🎉')
  const [buttonClickCount, setButtonClickCount] = useState(0)

  const [counterFieldValue, setCounterFieldValue] = useState('Dette er verdi')
  const { handleSubmit, register, getValues } = useForm<FormData>({
    defaultValues: {
      firstValue: 'First value',
      secondValue: 'Second value',
    },
  })
  const MOCK_SUBMIT = useMemo(() => {
    return () => {
      const values = getValues()
      alert('Submitting ' + JSON.stringify(values))
    }
  }, [getValues])

  const textareaRef = useRef<HTMLTextAreaElement>(null)

  return (
    <>
      <main className="page-main pkt-container">
        <h1>Textarea</h1>

        <section className="component">
          <PktTextarea
            id="testinput1"
            label={'Tekstarea (Klikket: ' + buttonClickCount + ' ganger)'}
            value={aValue}
            onChange={(e) => {
              console.log('onChange', e.target)
              setAValue(e.target.value)
            }}
            helptext={
              <>
                <PktButton
                  size="small"
                  skin="secondary"
                  onClick={(e) => {
                    setButtonValue('🥳')
                    setButtonClickCount(buttonClickCount + 1)
                  }}
                >
                  {buttonValue}
                </PktButton>
                &nbsp;Dette er tekstfelt med en knapp som kan klikkes på for å endre tekst
              </>
            }
            ref={textareaRef}
          ></PktTextarea>
          <PktMessagebox>En verdi: {aValue}</PktMessagebox>
          <PktButton onClick={() => setAValue('ding')}>Reset</PktButton>
          <br />

          <PktTextarea
            id="testinput2"
            label="Tekstarea med hjelpetext"
            helptext="Dette er tekst over tekstfeltet"
            fullwidth
          ></PktTextarea>
          <br />

          <PktTextarea
            id="testinput33"
            label="Tekstarea inline"
            helptext="Dette er tekst over tekstfeltet"
            inline
          ></PktTextarea>
          <br />

          <PktTextarea
            id="testinput44"
            label="Tekstarea inline"
            helptext="Dette er tekst over tekstfeltet"
            tagText="Taggtekst"
            inline
          ></PktTextarea>
          <br />

          <PktTextarea
            id="testinput3"
            label="Tekstarea med tag"
            helptext="Dette er tekst over tekstfeltet"
            requiredTag
          ></PktTextarea>
          <br />

          <PktTextarea
            id="testinput4"
            label="Tekstarea med tag"
            helptext="Dette er tekst over tekstfeltet"
            optionalTag
          ></PktTextarea>
          <br />

          <PktTextarea
            id="testinput5"
            label="Tekstarea med teller"
            helptext="Dette er tekst over tekstfeltet"
            counter
            counterMaxLength={25}
            value={counterFieldValue}
            onChange={(e) => setCounterFieldValue(e.target.value)}
          ></PktTextarea>
          <br />

          <PktTextarea
            id="testinput52"
            label="Tekstarea med 50 rader"
            helptext="Dette er tekst over tekstfeltet"
            rows={50}
          ></PktTextarea>
          <br />

          <PktTextarea
            id="testinput9"
            label="Tekstarea med error"
            helptext="Dette er tekst over tekstfeltet"
            errorMessage="Dette er en feilmelding"
            hasError
          ></PktTextarea>
          <br />

          <PktTextarea
            id="testinput10"
            label="Tekstarea med dropdown"
            helptext="Bruk dette tekstfeltet til å skrive en kort varsling."
            helptextDropdown="Dette er hjelpetekst"
            optionalTag
          ></PktTextarea>
          <br />

          <PktTextarea
            id="testinput12"
            label="Tekstarea med dropdown"
            helptext="Bruk dette tekstfeltet til å skrive en kort varsling."
            helptextDropdown="Dette er hjelpetekst"
            errorMessage="Dette er en feilmelding"
            hasError
          ></PktTextarea>
          <br />

          <PktTextarea
            id="testinput11"
            label="Tekstarea disabled med custom dropdownknapp"
            helptext="Bruk dette tekstfeltet til å skrive en kort varsling."
            helptextDropdown="Dette er hjelpetekst"
            helptextDropdownButton="Denne knappen åpner hjelpetekst"
            disabled
          ></PktTextarea>
          <br />

          <PktTextarea id="testinput13" label="Tekstarea enkel disabled" disabled></PktTextarea>
        </section>
        <section className="component">
          <h2>Test av reell skjemaintegrasjon</h2>
          <form onSubmit={handleSubmit(MOCK_SUBMIT)}>
            <PktTextarea id="firstValue" label="Første verdi" {...register('firstValue')} />
            <br />
            <PktTextarea
              id="secondValue"
              label="Andre verdi"
              {...register('secondValue')}
              helptextDropdown="Dette er hjelpetekst"
            />
            <br />
            <PktButton type="submit">Submit</PktButton>
          </form>
        </section>
      </main>
    </>
  )
}
